import { TextField } from "@mui/material";
import styles from "../../../../propertydetails.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import * as yup from "yup";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../../../../components/AddLogs";
import { toast } from "react-smart-toaster";
import { useState } from "react";

const phoneRegExp = /^\(?([0-9]{3})\)?[ ]?([0-9]{3})[-]?([0-9]{4})$/;
const schema = yup.object().shape({
    twilio_number: yup.string().required("This field is Required").test('is-valid-phone', 'Invalid phone number', function (value) {
        if (!value || value.trim() === '') return true;
        return phoneRegExp.test(value);
    })
});

const PhoneField = (props) => {
    return (<NumberFormat
        prefix=""
        displayType="input"
        type="tel"
        format={"(###) ###-####"}
        {...props}
    />);
}

const PropertyTwilioNumber = ({ twilio_number, setLoading, setSnackbarMsg, setSnackbarOpen, setPropertyData, property_name, property_id }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { handleSubmit, control, errors, setValue } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema),
    });

    const [isEditable, setIsEditable] = useState(false);

    useEffect(() => {
        if (twilio_number) {
            setValue('twilio_number', twilio_number);
        }
    }, [twilio_number, setValue])

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/update-twilio_number", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                return { ...prev, twilio_number: response.data?.data?.twilio_number };
            });

            let logData = {
                title: "Prespect twilio number has been updated",
                description: ["Property: " + property_name],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ maxWidth: "300px" }}>
            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`twilio_number`}
                        control={control}
                        render={(field) => (
                            <PhoneField
                                value={field.value}
                                onChange={(e) => {
                                    field.onChange(e);

                                    if (e.target.value !== twilio_number) {
                                        setIsEditable(true);
                                    } else {
                                        setIsEditable(false);
                                    }
                                }}
                                customInput={TextField}
                                prefix=""
                                displayType="input"
                                type="text"
                                thousandSeparator={false}
                                decimalScale={0}
                                label="Twilio Number"
                                variant="outlined"
                            />)}
                    />
                    {errors.twilio_number && (<p className={`${styles.ErrorM}`}>{errors?.twilio_number?.message}</p>)}
                </div>
            </div>

            <div>
                <button type="submit" className={`${styles.ButtonVoiletSolid}`} disabled={!isEditable}>Update</button>
            </div>
        </div>
    </form>)
}

export default PropertyTwilioNumber;